import { T, useGT } from 'gt-react';
import type { OverrideAction } from './overrideActions';

function isOverrideAction(v: string): v is OverrideAction {
  return v === 'buy' || v === 'transfer' || v === 'buy_and_transfer';
}

export function OverrideActionField({
  choices,
  value,
  onChange,
  inputClass,
}: {
  choices: OverrideAction[];
  value: OverrideAction;
  onChange: (action: OverrideAction) => void;
  inputClass: string;
}) {
  const gt = useGT();
  if (choices.length === 0) return null;
  const label = (choice: OverrideAction) =>
    choice === 'buy'
      ? gt('Buy', { context: 'option action label' })
      : choice === 'transfer'
        ? gt('Transfer', { context: 'option action label' })
        : gt('Buy + Transfer', { context: 'option action label' });
  return (
    <label className="flex flex-col gap-1">
      <span className="text-gray-500">
        <T context="override field action">Action</T>
      </span>
      <select
        value={value}
        onChange={(e) => {
          if (isOverrideAction(e.target.value)) onChange(e.target.value);
        }}
        className={inputClass}
      >
        {choices.map((choice) => (
          <option key={choice} value={choice}>
            {label(choice)}
          </option>
        ))}
      </select>
    </label>
  );
}
